import { useEffect, useRef } from 'react';

/**
 * Body scroll lock hook for preventing background scrolling
 * Useful for mobile overlays, modals, and sidebars
 * Only applies on mobile devices (screen width < 768px)
 */
export const useBodyScrollLock = (isLocked: boolean) => {
  const previousBodyOverflow = useRef<string>('');
  const previousBodyPaddingRight = useRef<string>('');

  useEffect(() => {
    // Only apply on mobile devices
    const isMobile = window.innerWidth < 768;
    if (!isLocked || !isMobile) return;

    const body = document.body;
    const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

    // Store original values
    previousBodyOverflow.current = body.style.overflow;
    previousBodyPaddingRight.current = body.style.paddingRight;

    // Apply scroll lock
    body.style.overflow = 'hidden';
    
    // Prevent layout shift by adding padding for scrollbar width
    if (scrollBarWidth > 0) {
      body.style.paddingRight = `${scrollBarWidth}px`;
    }

    // Cleanup function
    return () => {
      body.style.overflow = previousBodyOverflow.current;
      body.style.paddingRight = previousBodyPaddingRight.current;
    };
  }, [isLocked]);

  useEffect(() => {
    // Cleanup on unmount
    return () => {
      const body = document.body;
      body.style.overflow = previousBodyOverflow.current;
      body.style.paddingRight = previousBodyPaddingRight.current;
    };
  }, []);
};